import { forwardRef, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
// @mui
import { Box } from "@mui/material";
//
import getRatio from "./getRatio";
import { ImageProps } from "./types";
import ImageZoom from "./ImageZoom";
import { PhotoProvider, PhotoView } from "react-photo-view";

// ----------------------------------------------------------------------

const Image = forwardRef<HTMLSpanElement, ImageProps>(
  (
    {
      ratio,
      disabledEffect = false,
      effect = "blur",
      sx,
      scale = true,
      clickScale = true,
      ...other
    },
    ref
  ) => {
    const [open, setOpen] = useState(false);

    const content = (
      <Box
        component={LazyLoadImage}
        wrapperClassName="wrapper"
        effect={disabledEffect ? undefined : effect}
        placeholderSrc={
          disabledEffect ? "/assets/transparent.png" : "/assets/placeholder.svg"
        }
        sx={{
          width: 1,
          height: 1,
          objectFit: "cover",
        }}
        onClick={() => {
          if (scale) {
            setOpen(true);
          }
        }}
        {...other}
      />
    );

    if (ratio) {
      return (
        <Box
          ref={ref}
          component="span"
          sx={{
            width: 1,
            lineHeight: 1,
            display: "block",
            overflow: "hidden",
            position: "relative",
            pt: getRatio(ratio),
            "& .wrapper": {
              top: 0,
              left: 0,
              width: 1,
              height: 1,
              position: "absolute",
              backgroundSize: "cover !important",
            },
            ...sx,
          }}
        >
          <ImageZoom
            open={open}
            onClose={(v) => {
              setOpen(false);
            }}
            children={content}
          />
          {content}
        </Box>
      );
    }

    return (
      <Box
        ref={ref}
        component="span"
        sx={{
          lineHeight: 1,
          display: "block",
          overflow: "hidden",
          position: "relative",

          "& .wrapper": {
            width: 1,
            height: 1,
            backgroundSize: "cover !important",
          },
          ...sx,
        }}
      >
        {clickScale ? (
          <PhotoProvider>
            <PhotoView src={other.src}>{content}</PhotoView>
          </PhotoProvider>
        ) : (
          content
        )}

        {/* <ImageZoom
          open={open}
          onClose={(v) => {
            setOpen(false);
          }}
          children={content}
        /> */}
        {/* {content} */}
      </Box>
    );
  }
);

export default Image;
